import {
  ChangeDetectorRef,
  Component,
  QueryList,
  ViewChildren
} from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { FieldType } from '@ngx-formly/core';
import { AppService } from '../app.service';
import { BogTourService } from '../services/bog-tour/bog-tour.service';
@Component({
    selector: 'custom-multicheckbox',
    styles: [`
      .lottie_player{
        border-radius:50%;
      }
      .my_button {
        text-align:center;padding-top:4px;height:30px;width:30px;border:1px solid #898989;border-radius:50%;
      }
      .thumps_up{
        text-align:center;padding-top:4px;height:30px;width:30px;border:1px solid #898989;border-radius:50%;
      }
      .thumbs_down{
        margin-left:10px;text-align:center;height:30px;width:30px;border-radius:50%;border: 1px solid #707070;
        border-radius: 50%;
        padding-top: 7px;
      }
      .thumbs_down_selected{
        margin-left:10px;padding-top:8px;text-align:center;height:30px;width:30px;background-color:#F000144D;border-radius:50%;
      }
      .thumps_up_selected{
        height: 30px;
        width: 30px;text-align:center;background:#0091464D;border-radius:50%;
      }
      .row_style{
        box-shadow: 0px 3px 6px #00000029;
        background: white;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        padding: 6px;
      }
      .row_style input {
        display:none;
      }
      .thumbsup_lottie{
        width: 45px;
        height: 45px;
        margin-left: -8px;
        margin-top: -14px;
      }
      .thump_up_svg{
        height:17px;
      }
  `],
    template: `
  <ion-row class="row_style"  [ngStyle]="{'color': to.tippleColor}" *ngFor="let option of to.options; let i = index" (click)="itemClick(i)">
    <ion-col class="ion-align-self-center">
      <ion-label style="font-size:14px;">{{ option.label }}</ion-label>
    </ion-col>
    <ion-col class="ion-align-self-center" size="3">
    <div  style="display:flex">
      <div id="{{option.label}}" [attr.aria-label]="'thumps_up'+i"
          [attr.role]="'thumps_up'+i" 
          [attr.Accessibility-ID]="'thumps_up'+i" (click)="onChange(option, 'Checked')" class="thumps_up" [ngClass]="{'thumps_up_selected': option.checked == 'Checked' }">
          <img  *ngIf="option.checked == 'Not Applicable'" [attr.aria-label]="'thumps_up1'+i"
          [attr.role]="'thumps_up1'+i" 
          [attr.Accessibility-ID]="'thumps_up1'+i"  src='assets/img/bog_tour/relates_to_thums_up.svg'/>
          <img *ngIf="option.checked == 'Not Checked'" [attr.aria-label]="'thumps_up2'+i"
          [attr.role]="'thumps_up2'+i" 
          [attr.Accessibility-ID]="'thumps_up2'+i"  src='assets/img/bog_tour/relates_to_thums_up.svg'/>
          <img *ngIf="option.checked == 'Checked'" [attr.aria-label]="'thumps_up1'+i"
          [attr.role]="'thumps_up1'+i" class="thump_up_svg"
          [attr.Accessibility-ID]="'thumps_up1'+i"  src='assets/img/bog_tour/thumbs_up_selected.svg'/>
        <!--  <lottie-player class="thumbsup_lottie" *ngIf="option.checked == 'Checked' && appservice.connectionState" src="assets/area-management/Thumb like.json" background="transparent" speed="1"   speed="1"   autoPlay></lottie-player> -->
      </div>
      <div id="{{option.label}}" [attr.aria-label]="option.label+i"
          [attr.role]="option.label+i" 
          [attr.Accessibility-ID]="option.label+i" (click)="onChange(option, 'Not Checked')" class="thumbs_down" [ngClass]="{'thums_down_selected':option.checked == 'Checked'}" >
          <img *ngIf="option.checked == 'Not Applicable'" [attr.aria-label]="'relates_to_thums_down'+i"
          [attr.role]="'relates_to_thums_down'+i" 
          [attr.Accessibility-ID]="'relates_to_thums_down'+i" src='assets/img/bog_tour/relates_to_thums_down.svg'/>
          <img *ngIf="option.checked == 'Not Checked'" [attr.aria-label]="'thums_down_selected'+i"
          [attr.role]="'thums_down_selected'+i" 
          [attr.Accessibility-ID]="'thums_down_selected'+i" src='assets/img/bog_tour/thums_down_selected.svg'/>
          <img *ngIf="option.checked == 'Checked'" [attr.aria-label]="'relates_to_thums_down1'+i"
          [attr.role]="'relates_to_thums_down1'+i" 
          [attr.Accessibility-ID]="'relates_to_thums_down1'+i" src="assets/img/bog_tour/relates_to_thums_down.svg"/>
      </div>
    </div>
      
    </ion-col>
  <ion-row>
  `,
    standalone: false
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class MultiCheckboxFormlyType extends FieldType {
  @ViewChildren(MatSlideToggle) toggles: QueryList<MatSlideToggle>;

  constructor(private changeDetector: ChangeDetectorRef,public appservice:AppService,public bogService:BogTourService) {
    super();
  }
  
  onChange(option: any, checked: string) {
    if(this.to.disabled){
      return
    }
    option.checked = checked;
    this.formControl.patchValue(this.to.options);
    this.formControl.markAsTouched();

    let currentSelect:any=option;
    let exisitngRelatesTo=this.bogService.selectedRelatesTo;
    let findIndex=exisitngRelatesTo.findIndex(obj => obj.id==currentSelect.id);
    if(findIndex ==-1)
      this.bogService.selectedRelatesTo.push(currentSelect);
    else this.bogService.selectedRelatesTo[findIndex]=currentSelect;
  }

  onContainerClick(event: MouseEvent): void {
    if(this.to.disabled){
      return
    }
    if (this.toggles.length) {
      this.toggles.first.focus();
    }
    //this.onContainerClick(event);
  }

  itemClick(index) {
    //this.toggles.toArray()[index].toggle();
  }

  
  //replace toggle button with like icon
  // <mat-slide-toggle
      //   [id]="id + '_' + i"
      //   [formlyAttributes]="field"
      //   [tabindex]="to.tabindex"
      //   [color]="to.color"
      //   [labelPosition]="to.labelPosition"
      //   [required]="to.required"
      //   [checked]="option.checked"
      //   [disabled]="formControl.disabled"
      //   (change)="onChange(option, $event.checked)"
      // >
      // </mat-slide-toggle>


//       <mat-list>
//   <mat-list-item
//     matRipple
//     [matRippleColor]="to.rippleColor"
//     *ngFor="let option of to.options; let i = index"
//     (click)="itemClick(i)"
//   >
//     <h3 mat-line>{{ option.label }}</h3>
     
//     <div  *ngIf='!option.checked' (click)="onChange(option, $event.checked)" style='height:30px !important;width:30px !important;background-color:#0091464D;'>
//       <img  src='assets/img/bog_tour/thums_up.svg'/>
//     </div>
//     <div *ngIf='option.checked' (click)="onChange(option, $event.checked)" style='height:30px !important;width:30px !important;background-color:#F000144D;'>
//       <img  src='assets/img/bog_tour/thums_down.svg'/>
//     </div>
//   </mat-list-item>
// </mat-list>

// <div  *ngIf='!option.checked' (click)="onChange(option, $event.checked)" style='height:30px !important;width:30px !important;background-color:#0091464D;'>
// <img  src='assets/img/bog_tour/thums_up.svg'/>
// </div>
// <div *ngIf='option.checked' (click)="onChange(option, $event.checked)" style='height:30px !important;width:30px !important;background-color:#F000144D;'>
// <img  src='assets/img/bog_tour/thums_down.svg'/>
// </div>
}
